import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import languageMapper from "../shared";
import Logo from "../logo512.png";
import { useTranslation } from "react-i18next";
import "../i18n";
import { MathJax } from "better-react-mathjax";
import { baseUrl } from "../shared";
import SharedStateContext from "../context/sharedstate";
import Navbar from "../navbar";
import Navbaranonuser from "../navbaranonuser";
import { AuthContext } from "../context/AuthContext";
import NoResultsModal from "./NoResultsModal";
import { groupResultsByWordEnglish, exactMatchesFirst } from "../groupResultsByWordEnglish";
import PendingBadge from "./PendingBadge";

function AdvancedSearch({ isLoggedIn, onLogout }) {
  const { auth } = useContext(AuthContext);
  const [noResults, setNoResults] = useState(false); 
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  // Claude: bugfix reported during UAT — "clicking on a word that was found, and then on 'back',
  // Claude: the empty search page is displayed. It would be better to return to the results page."
  // Claude: Same fix as LandingPage.js: the search form and its results now live in
  // Claude: SharedStateContext (advancedSearch) instead of local component state, since that
  // Claude: context sits above the router and survives the unmount/remount React Router does when
  // Claude: navigating to /phrase/:id and back. Everything below still reads/writes these fields
  // Claude: exactly as before; only where they're declared changed.
  const { advancedSearch, setAdvancedSearch } = useContext(SharedStateContext);
  const { searchTerm, sourceLanguage, targetLanguage, partialMatch, fuzzyMatch, field, status, phrases } = advancedSearch;
  const setSearchTerm = (value) => setAdvancedSearch({ ...advancedSearch, searchTerm: value });
  const setSourceLanguage = (value) => setAdvancedSearch({ ...advancedSearch, sourceLanguage: value });
  const setTargetLanguage = (value) => setAdvancedSearch({ ...advancedSearch, targetLanguage: value });
  const setPartialMatch = (value) => setAdvancedSearch({ ...advancedSearch, partialMatch: value });
  // Claude: alpha-tester feedback — "a more capable search function... will also find a word even
  // Claude: when there is a spelling mistake." Added as its own opt-in option next to "Partial
  // Claude: match", per the request, rather than replacing/always-on behavior.
  const setFuzzyMatch = (value) => setAdvancedSearch({ ...advancedSearch, fuzzyMatch: value });
  const setField = (value) => setAdvancedSearch({ ...advancedSearch, field: value });
  const setStatus = (value) => setAdvancedSearch({ ...advancedSearch, status: value });
  const setPhrases = (value) => setAdvancedSearch({ ...advancedSearch, phrases: value });
  const [gtPhrase, setGtPhrase] = useState([]);

    const handleGtSearch = async () => {
      setIsLoading(true); // Start loading
      setGtPhrase("");
      const response = await fetch(
        baseUrl +
          `v1/translate_term/${sourceLanguage}/${targetLanguage}/${encodeURIComponent(
            searchTerm
          )}/${partialMatch}`
      );
      const data = await response.json();
      console.log("data", data.translated_term);
      // Claude: bugfix found during UAT — a real "Cannot read properties of undefined (reading
      // 'length')" crash. translate_term returns {error: ...} (no translated_term key at all) on
      // failure — e.g. when the Gemini model changes out from under this endpoint, as it did (see
      // the model-name fix in views.py) — so this needs the same "does the key even exist" guard
      // LandingPage.js's identical handleGtSearch already has, rather than assuming success.
      if (typeof data.translated_term !== 'undefined') {
        if (data.translated_term.length === 0) {
          setNoResults(true); // Show modal if no results
          setIsLoading(false); // End loading
        } else {
          setIsLoading(false); // End loading
          console.log("translated data", data);
          setGtPhrase(data.translated_term);
        }
      } else {
        setGtPhrase("undefined");
        setNoResults(true); // Show modal if no results
        setIsLoading(false); // End loading
      }
    };

  const handleSearch = async () => {
    setIsLoading(true); // Start loading
    const response = await fetch(
      baseUrl +
        `v1/advanced/${sourceLanguage}/${targetLanguage}/${encodeURIComponent(
          searchTerm ? searchTerm : "*"
        )}/${partialMatch}/${field ? field : "All"}/${status}` +
        (fuzzyMatch ? "?fuzzy=true" : "")
    );
    const data = await response.json();
    if (data["Terme in databasis"].length === 0) {
      // Claude: alpha-tester feedback — "Old results remain after an unsuccessful search." Same
      // Claude: fix as LandingPage.js.
      setPhrases([]);
      handleGtSearch();
      setNoResults(true); // Show modal if no results
      setIsLoading(false); // End loading
    } else {
      setIsLoading(false); // End loading
      // Claude: fuzzy searches only — exact matches first (see exactMatchesFirst), same as
      // Claude: LandingPage.js.
      setPhrases(
        fuzzyMatch
          ? exactMatchesFirst(data["Terme in databasis"], searchTerm, sourceLanguage)
          : data["Terme in databasis"]
      );
    }

    // setPhrases(data["Terme in databasis"]); // Perform search logic here
    // console.log(`Searching for v1/advanced/${sourceLanguage}/${targetLanguage}/${encodeURIComponent(
    //       searchTerm ? searchTerm : "*"
    //     )}/${partialMatch}/${field ? field : "All"}/${status} `);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // const handleModalKeyDown = (event) => {
  //   if (event.key === "Enter") {
  //     handleRequestSubmit();
  //   }
  // };

  //  function handleRequestEnter(e){
  //  var key = 'which' in e ? e.which : e.keyCode;
  //  if (key == 13) {
  //    handleRequestSubmit()
  //  }
  // }

  const handleRequestSubmit = async (suggestedTerm) => {
    await fetch(`${baseUrl}v1/request-term/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        term: searchTerm,
        suggestedTerm,
        targetLanguage,
        sourceLanguage,
        username: auth?.userName || "anonymous",
      }),
    });
    // if (response.ok) {
    //   alert("Request submitted successfully");
    // } else {
    //   alert("Failed to submit request");
    // }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <>
        {/* <Navbar /> */}
        {/* {auth.userRole === "editor" && <Navbar />}
        {auth.userRole !== "editor" && <Navbaranonuser />} */}
        {localStorage.setItem("bladsy", "AdvancedSearch")}
        {auth.userName === null && <Navbaranonuser />}
        {auth.userName != null && <Navbar />}
        <div className="flex flex-col justify-center items-center p-4">
          <h1 className="text-4xl font-bold mb-6">
            <a href="/" className="inline-block">
              {t("advanced")}
            </a>
          </h1>
          <div className="w-full max-w-3xl bg-white rounded-lg shadow-lg p-6">
            <input
              type="text"
              value={searchTerm}
              // defaultValue="*"
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder={t("enter")}
              className="border border-2 p-2 mb-4 w-full max-w-3xl rounded-lg"
            />

            <div className="mb-4">
              <label
                htmlFor="sourceLanguage"
                className="block text-lg font-medium mb-2"
              >
                {t("source")}
              </label>
              <select
                id="sourceLanguage"
                value={sourceLanguage}
                onChange={(e) => setSourceLanguage(e.target.value)}
                className="w-full p-2 border rounded-lg"
              >
                <option value="Eng">English</option>
                <option value="Afr">Afrikaans</option>
                <option value="Zul">isiZulu</option>
                <option value="Ses">Sesotho</option>
                <option value="Sep">Sepedi</option>
                <option value="Set">Setswana</option>
                <option value="Xit">Xitsonga</option>
                <option value="Sis">siSwati</option>
                <option value="Nde">isiNdebele</option>
                <option value="Xho">isiXhosa</option>
                <option value="Tsh">Tshivenḓa</option>
                <option value="Por">Portuguese</option>
                <option value="Fre">French</option>
              </select>
            </div>

            <div className="mb-4">
              <label
                htmlFor="targetLanguage"
                className="block text-lg font-medium mb-2"
              >
                {t("target")}
              </label>
              <select
                id="targetLanguage"
                value={targetLanguage}
                onChange={(e) => setTargetLanguage(e.target.value)}
                className="w-full p-2 border rounded-lg"
              >
                <option value="All">{t("alllanguages")}</option>
                <option value="Eng">English</option>
                <option value="Afr">Afrikaans</option>
                <option value="Zul">isiZulu</option>
                <option value="Ses">Sesotho</option>
                <option value="Sep">Sepedi</option>
                <option value="Set">Setswana</option>
                <option value="Xit">Xitsonga</option>
                <option value="Sis">siSwati</option>
                <option value="Nde">isiNdebele</option>
                <option value="Xho">isiXhosa</option>
                <option value="Tsh">Tshivenḓa</option>
                <option value="Por">Portuguese</option>
                <option value="Fre">French</option>
              </select>
            </div>

            <div className="mb-4">
              <label
                htmlFor="targetLanguage"
                className="block text-lg font-medium mb-2"
              >
                {t("context")}
              </label>

              <input
                type="text"
                value={field}
                onChange={(e) => setField(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={t("context")}
                className="border p-3 mb-2 w-full max-w-3xl rounded-lg"
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="status"
                className="block text-lg font-medium mb-2"
              >
                {t("status")}
              </label>
              <select
                name="status"
                value={status}
                // defaultValue="PND"
                onChange={(e) => setStatus(e.target.value)}
                className="w-full p-2 border rounded-lg"
              >
                <option value="All">{t("allstatus")}</option>
                <option value="ACC">{t("accepted")}</option>
                <option value="PND">{t("pending")}</option>
                <option value="REJ">{t("rejected")}</option>
                <option value="FLG">{t("flagged")}</option>
              </select>
            </div>

            <div className="mb-4">
              <label className={`inline-flex items-center ${fuzzyMatch ? "opacity-50" : ""}`}>
                <input
                  type="checkbox"
                  checked={partialMatch}
                  onChange={() => setPartialMatch(!partialMatch)}
                  disabled={fuzzyMatch}
                  className="form-checkbox h-5 w-5 text-cyan-700 accent-cyan-700 disabled:cursor-not-allowed"
                />
                <span className="ml-2 text-lg font-medium">{t("partial")}</span>
              </label>
            </div>

            {/* Claude: alpha-tester feedback — "a more capable search function... will also find a
                word even when there is a spelling mistake." Bugfix reported directly — checking both
                this and "Partial match" silently ignored "Partial match" server-side (soek/advanced
                check fuzzy first) with no indication anything was ignored. Disabling/greying out
                "Partial match" while this is checked makes that visible instead of silent. */}
            <div className="mb-4">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  checked={fuzzyMatch}
                  onChange={() => setFuzzyMatch(!fuzzyMatch)}
                  className="form-checkbox h-5 w-5 text-cyan-700 accent-cyan-700"
                />
                <span className="ml-2 text-lg font-medium">{t("fuzzy")}</span>
              </label>
            </div>

            <button
              onClick={handleSearch}
              className="w-full bg-cyan-700 text-white py-2 px-4 rounded-lg hover:bg-cyan-800"
            >
              {t("search")}
            </button>
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div
                  className="inline-block mt-6 h-8 w-8 animate-spin rounded-full text-cyan-900 border-4 border-solid border-current border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite]"
                  role="status"
                >
                  <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                    Loading...
                  </span>
                </div>
              </div>
            ) : (
              <ul>
                <div className="block max-2-96 py-2">
                  {/* Claude: alpha-tester feedback — "it is not clear in the list of results which
                      words across the languages are related." Results sharing the same English
                      backbone term (wordEnglish) are grouped into one bordered card, headed by a
                      pill naming that backbone term — see LandingPage.js's identical results
                      rendering and groupResultsByWordEnglish.js. */}
                  {groupResultsByWordEnglish(phrases).map((group) => (
                    <li key={group.wordEnglish} className="border-2 rounded p-2 mb-4">
                      <span className="inline-block bg-cyan-100 text-cyan-800 text-sm font-semibold px-2 py-1 rounded mb-2">
                        {languageMapper("Eng")}: {group.wordEnglish}
                      </span>
                      {group.items.map((searchTerm) => (
                        <div key={searchTerm._id} className="border-t p-2">
                          <Link to={`/phrase/${searchTerm._id}`}>
                            <MathJax>
                              <h3 className="text-xl">
                                {searchTerm.word}
                                <PendingBadge status={searchTerm.status} />
                              </h3>
                              <p>
                                {t("language")}:{" "}
                                {languageMapper(searchTerm.language)}
                              </p>
                              <p>
                                {t("context")}: {searchTerm.field}
                              </p>
                            </MathJax>
                          </Link>
                        </div>
                      ))}
                    </li>
                  ))}
                </div>
              </ul>
            )}
          </div>
        </div>
        <div className="flex flex-col justify-center items-center p-4">
          <Link to={"/"}>
            <img src={Logo} alt="Logo" width="100" height="100" />
          </Link>
        </div>
        <NoResultsModal
          shouldFocusAfterRender={true}
          isOpen={noResults}
          onClose={() => setNoResults(false)}
          searchTerm={searchTerm}
          targetLanguage={targetLanguage}
          sourceLanguage={sourceLanguage}
          gtTerm={gtPhrase}
          // onKeyDown={handleModalKeyDown}
          onSubmit={handleRequestSubmit}
        />
      </>
    </div>
  );
}

export default AdvancedSearch;
